import { StockAdjustmentReason } from "@/redux/services/inventory/inventory.type";
import { getStockAdjustmentReasonLabel } from "@/lib/utils";
import { cn } from "@/lib/utils";

const REASON_STYLES: Record<StockAdjustmentReason, string> = {
  delivery: "bg-green-100 text-green-700",
  waste: "bg-red-100 text-red-700",
  correction: "bg-blue-100 text-blue-700",
  return: "bg-amber-100 text-amber-700",
  order_deduction: "bg-slate-100 text-slate-700",
  cost_correction: "bg-purple-100 text-purple-700",
  cancellation: "bg-rose-100 text-rose-700",
};

interface AdjustmentReasonBadgeProps {
  reason: StockAdjustmentReason;
}

const AdjustmentReasonBadge = ({ reason }: AdjustmentReasonBadgeProps) => (
  <span
    className={cn(
      "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
      REASON_STYLES[reason]
    )}
  >
    {getStockAdjustmentReasonLabel(reason)}
  </span>
);

export default AdjustmentReasonBadge;
